import { useTranslator } from '../translator/hook'
import './loadingScreen.css'
import block1 from './block1.svg'
import block2 from './block2.svg'
import block3 from './block3.svg'

export const LoadingScreen = () => {
  const { t } = useTranslator()

  return (
    <div className="loading-screen">
      <div className="loading-block-container">
        <img src={block1} alt="block1" />
        <img src={block2} alt="block2" />
        <img src={block3} alt="block3" />
      </div>
      <div>{t('loading_screen_text')}</div>
    </div>
  )
}
